import { initContract } from "@ts-rest/core";
import { OrganizationDto } from "../dto/organization/organization.dto";

const c = initContract();

export const organizationContract = c.router(
    {
        listOrganizations: {
            method: "GET",
            path: "/",
            responses: {
                200: c.type<OrganizationDto[]>(),
            },
        },
        updateOrganization: {
            method: "PUT",
            path: "/:organizationId",
            body: c.type<{ name: string }>(),
            responses: {
                200: c.type<OrganizationDto>(),
            },
        },
    },
    {
        pathPrefix: "/organization",
    },
);
